// Mock data for portfolio - will be replaced with backend integration later

export const portfolioData = {
  hero: {
    name: "TRAORE Djakaridia",
    title: "Ingénieur Développeur | Expert en Big Data & Architecture Distribuée",
    tagline: "Ingénieur en Big Data avec 5 ans d'expérience dans la conception de solutions data-driven, l'architecture distribuée et le développement d'applications scalables. Spécialisé dans la transformation des données en solutions intelligentes.",
    github: "https://github.com/Djakaridia",
    linkedin: "https://www.linkedin.com/in/djakaridia-t-a3218b176",
    email: "djakaridiatraore7920@gmail.com",
    phone: "(+223) 71 97 58 33",
    whatsapp: "https://wa.me/22371975833",
    location: "Mali",
    cv: "documents/Djakaridia_TRAORE_CURRENT.pdf"
  },
  
  about: {
    image: "images/profile.png",
    description: "Ingénieur Développeur spécialisé en Big Data avec une solide expérience dans la conception et le développement de solutions data-driven. Diplômé de l'École Nationale des Sciences Appliquées du Maroc, j'ai travaillé sur des projets internationaux au Mali, Canada, Maroc, Niger, Mauritanie, Burundi et Côte d'Ivoire. Expert en architecture distribuée, traitement de données massives et développement d'applications intelligentes. Passionné par l'innovation technologique et l'optimisation des performances, je combine expertise technique et vision stratégique pour livrer des solutions à fort impact.",
    yearsOfExperience: 5,
    projectsCompleted: 15,
    clientsSatisfied: 10,
    certifications: ["OCI Foundations 2021 Associate", "Oracle Autonomous Database 2021 Specialist", "HCIA-AI V3.0"],
    languages: [
      { name: "Français", level: "Courant", spoken: true, written: true },
      { name: "Anglais", level: "Courant", spoken: true, written: true },
      { name: "Bambara", level: "Maternel", spoken: true, written: false }
    ]
  },
  
  projects: [
    {
      id: 0,
      name: "MRV-Burundi (Monitoring, Reporting, and Verification)",
      description: "Système complet de collecte et d'analyse des données multi-sources pour le suivi environnemental au Burundi",
      image: "https://images.pexels.com/photos/5380642/pexels-photo-5380642.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      technologies: ["PHP", "JavaScript", "ReactJS", "Bootstrap", "GreenAPI", "WordPress"],
      features: [
        "Conception et intégration du Back-Office et Front-Office",
        "Système de collecte de données multi-sources",
        "Analyse et visualisation des données environnementales",
        "Génération de rapports automatisés"
      ],
      githubUrl: null,
      liveUrl: null,
      category: "fullstack",
      date: "Février 2026",
      location: "Burundi"
    },
    {
      id: 1,
      name: "MRV-MALI (Monitoring, Reporting, and Verification)",
      description: "Système complet de collecte et d'analyse des données multi-sources pour le suivi environnemental au Mali",
      image: "https://images.pexels.com/photos/5380642/pexels-photo-5380642.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      technologies: ["PHP", "JavaScript", "ReactJS", "Bootstrap", "GreenAPI", "WordPress"],
      features: [
        "Conception et intégration du Back-Office et Front-Office",
        "Système de collecte de données multi-sources",
        "Analyse et visualisation des données environnementales",
        "Génération de rapports automatisés"
      ],
      githubUrl: null,
      liveUrl: null,
      category: "fullstack",
      date: "Mars 2025",
      location: "Mali"
    },
    {
      id: 2,
      name: "PDZSTA-KB",
      description: "Programme de développement de la zone spéciale de transformation agro-industrielle des régions de Koulikoro et péri-urbaine de Bamako",
      image: "https://images.pexels.com/photos/10020092/pexels-photo-10020092.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      technologies: ["PHP", "JavaScript", "GreenAPI", "Bootstrap"],
      features: [
        "Conception du système de suivi & évaluation",
        "Intégration des activités du projet",
        "Tableaux de bord de monitoring",
        "Génération de rapports d'activités"
      ],
      githubUrl: null,
      liveUrl: null,
      category: "fullstack",
      date: "Août 2025",
      location: "Mali"
    },
    {
      id: 3,
      name: "PRSA - Programme de Résilience du Système Alimentaire",
      description: "Programme régional pour la résilience du système alimentaire en Afrique de l'Ouest",
      image: "https://images.pexels.com/photos/6466143/pexels-photo-6466143.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      technologies: ["PHP", "JavaScript", "GreenAPI", "Bootstrap", "TinyButStrong"],
      features: [
        "Coordination et mise en œuvre du projet",
        "Mise en place du système de suivi & évaluation",
        "Intégration des activités régionales",
        "Tableaux de bord de performance"
      ],
      githubUrl: null,
      liveUrl: null,
      category: "fullstack",
      date: "Décembre 2024",
      location: "Niger"
    },
    {
      id: 4,
      name: "PROGRES - Gestion Durable des Ressources Naturelles",
      description: "Système de gestion durable des ressources naturelles et d'équipement communal",
      image: "https://images.pexels.com/photos/5380642/pexels-photo-5380642.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      technologies: ["PHP", "Bootstrap", "TinyButStrong"],
      features: [
        "Mise en place de systèmes de rapportage",
        "Tableau des bilans des données",
        "Suivi des activités communales",
        "Visualisation des indicateurs"
      ],
      githubUrl: null,
      liveUrl: null,
      category: "backend",
      date: "Décembre 2024",
      location: "Mauritanie"
    },
    {
      id: 5,
      name: "PRTD - Projet de Restauration des Terres Dégradées",
      description: "Programme de restauration et de suivi des terres dégradées au Mali",
      image: "https://images.pexels.com/photos/10020092/pexels-photo-10020092.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      technologies: ["PHP", "JavaScript", "GreenAPI", "Bootstrap", "TinyButStrong"],
      features: [
        "Coordination et mise en œuvre du projet",
        "Système de suivi évaluation des activités",
        "Monitoring des zones restaurées",
        "Génération de rapports d'impact"
      ],
      githubUrl: null,
      liveUrl: null,
      category: "fullstack",
      date: "Novembre 2024",
      location: "Mali"
    },
    {
      id: 6,
      name: "MASSY-COSIT",
      description: "Système de gestion de projet et gestion d'employés pour MASSY et COSIT",
      image: "https://images.pexels.com/photos/6466143/pexels-photo-6466143.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      technologies: ["Node.js", "Express", "Nodemailer", "GreenAPI", "AngularJS", "Bootstrap"],
      features: [
        "Coordination et mise en œuvre du projet",
        "Gestion des employés et des projets",
        "Méthodologie Agile",
        "Notifications automatiques"
      ],
      githubUrl: null,
      liveUrl: null,
      category: "fullstack",
      date: "Mars 2024",
      location: "Mali"
    },
    {
      id: 7,
      name: "Referme - Système de Référencement des Candidats",
      description: "Plateforme de référencement et de recrutement de candidats pour les entreprises",
      image: "https://images.pexels.com/photos/5380642/pexels-photo-5380642.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      technologies: ["Node.js", "Express", "Nodemailer", "Passport", "Stripe", "NextJS", "Tailwind CSS"],
      features: [
        "Système de référencement des candidats",
        "Développement Back-office et Front-office",
        "Authentification sécurisée",
        "Intégration des paiements Stripe"
      ],
      githubUrl: null,
      liveUrl: null,
      category: "fullstack",
      date: "Octobre 2023",
      location: "Canada"
    },
    {
      id: 8,
      name: "Automatisation des Processus de Recrutement",
      description: "Système d'extraction et traitement automatique des données des candidats",
      image: "https://images.pexels.com/photos/10020092/pexels-photo-10020092.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      technologies: ["Python", "BeautifulSoup", "Spacy", "Streamlit", "Zoho"],
      features: [
        "Extraction automatique des données candidats",
        "Traitement NLP avec Spacy",
        "Interface utilisateur avec Streamlit",
        "Intégration Zoho"
      ],
      githubUrl: null,
      liveUrl: null,
      category: "data",
      date: "Juillet 2022",
      location: "Maroc"
    }
  ],
  
  skills: {
    frontend: [
      { name: "ReactJS", level: 90 },
      { name: "NextJS", level: 85 },
      { name: "AngularJS", level: 80 },
      { name: "JavaScript/TypeScript", level: 90 },
      { name: "Tailwind CSS", level: 85 },
      { name: "Bootstrap", level: 90 }
    ],
    backend: [
      { name: "Node.js", level: 90 },
      { name: "Express", level: 90 },
      { name: "PHP", level: 85 },
      { name: "Python", level: 80 },
      { name: "REST API", level: 90 },
      { name: "GraphQL", level: 75 }
    ],
    database: [
      { name: "PostgreSQL", level: 85 },
      { name: "MySQL", level: 85 },
      { name: "Oracle", level: 80 },
      { name: "Redis", level: 75 }
    ],
    devops: [
      { name: "Docker", level: 85 },
      { name: "CI/CD", level: 80 },
      { name: "Git", level: 90 },
      { name: "Linux/Unix", level: 85 },
      { name: "Nginx", level: 80 }
    ],
    data: [
      { name: "BeautifulSoup", level: 85 },
      { name: "Spacy", level: 80 },
      { name: "Streamlit", level: 80 },
      { name: "SurveySolution", level: 85 }
    ],
    tools: [
      { name: "Git/GitHub", level: 90 },
      { name: "VS Code", level: 90 },
      { name: "Postman", level: 85 },
      { name: "GreenAPI", level: 85 },
      { name: "TinyButStrong", level: 80 }
    ]
  },
  
  experience: [
    {
      id: 1,
      title: "Directeur Technique, Ingénieur Développeur",
      company: "COSIT SARL",
      period: "Décembre 2023 - Présent",
      location: "Mali",
      achievements: [
        "Coordination des besoins fonctionnels et conception de systèmes de gestion de projets",
        "Intégration et déploiement des performances des applications",
        "Développement de systèmes de suivi et d'évaluation",
        "Génération de rapports et visualisations pour la prise de décision",
        "Direction technique de projets d'envergure nationale"
      ]
    },
    {
      id: 2,
      title: "Data Scientiste, Ingénieur Développeur Full Stack",
      company: "TargetCatcher Inc",
      period: "Octobre 2022 - Octobre 2023",
      location: "Canada",
      achievements: [
        "Gestion et analyse de projets internationaux",
        "Développement Back-end & API REST performantes",
        "Gestion de bases de données et optimisation du stockage",
        "Automatisation et extraction de données à grande échelle",
        "Développement Front-end et d'interface UI intuitive",
        "Intégration, déploiement et optimisation des applications"
      ]
    }
  ],
  
  certifications: [
    {
      name: "OCI Foundations 2021 Associate",
      issuer: "Oracle",
      date: "2021",
      location: "Maroc"
    },
    {
      name: "Oracle Autonomous Database 2021 Specialist",
      issuer: "Oracle",
      date: "2021",
      location: "Maroc"
    },
    {
      name: "HCIA-AI V3.0",
      issuer: "Huawei",
      date: "2021",
      location: "Maroc"
    }
  ],
  
  education: [
    {
      degree: "Ingénierie Informatique et Technologies Emergentes",
      specialization: "Option Big Data",
      institution: "Ecole Nationale des Sciences Appliquées",
      location: "Maroc",
      period: "2018 - 2021"
    },
    {
      degree: "Cycle Préparatoire d'Ingénieur",
      institution: "Ecole Nationale des Sciences Appliquées",
      location: "Maroc",
      period: "2016 - 2018"
    },
    {
      degree: "Baccalauréat Sciences Exactes",
      institution: "Lycée Baminata Coulibaly (LBAC)",
      location: "Mali",
      period: "2015"
    }
  ],
  
  problemsSolved: [
    {
      title: "Développement d'applications web scalables",
      description: "Création d'applications full-stack avec ReactJS, Node.js et PHP pour des projets internationaux au Mali, Canada, Niger et Mauritanie",
      icon: "Code"
    },
    {
      title: "Big Data & Data Analytics",
      description: "Conception de systèmes de collecte et d'analyse de données multi-sources pour le suivi environnemental et agricole",
      icon: "Database"
    },
    {
      title: "Automatisation des processus",
      description: "Développement de systèmes d'extraction et traitement automatique des données avec Python, BeautifulSoup et Spacy",
      icon: "GitBranch"
    },
    {
      title: "Systèmes de suivi & évaluation",
      description: "Mise en place de solutions complètes pour le monitoring et l'évaluation de projets de développement",
      icon: "Zap"
    },
    {
      title: "Intégration d'API et solutions cloud",
      description: "Intégration de GreenAPI, Stripe et solutions cloud Oracle pour des applications sécurisées et scalables",
      icon: "Cloud"
    }
  ]
};

export const chatbotResponses = {
  greeting: "Bonjour ! Je suis l'assistant virtuel de TRAORE Djakaridia, Ingénieur Développeur spécialisé en Big Data. Comment puis-je vous aider aujourd'hui ?",
  projects: "Djakaridia a travaillé sur de nombreux projets internationaux au Mali, Canada, Niger, Burundi, Mauritanie et Côte d'Ivoire, incluant le MRV-MALI, PDZSTA-KB, PRSA, PROGRES, PRTD, et Referme. Quel type de projet vous intéresse ?",
  skills: "Djakaridia maîtrise un large éventail de technologies : Frontend (ReactJS, NextJS, AngularJS), Backend (Node.js, Express, PHP, Python), Bases de données (PostgreSQL, MySQL, Oracle), DevOps (Docker, CI/CD) et Data Science (BeautifulSoup, Spacy, Streamlit). Il a 5 ans d'expérience en développement full-stack et Big Data.",
  experience: "Djakaridia est actuellement Directeur Technique chez COSIT SARL au Mali (depuis décembre 2023). Il a également travaillé pour TargetCatcher Inc au Canada (2022-2023) comme Data Scientiste et Ingénieur Développeur Full Stack. Il a mené des projets dans plusieurs pays africains.",
  certifications: "Djakaridia est certifié OCI Foundations 2021 Associate, Oracle Autonomous Database 2021 Specialist (Oracle), et HCIA-AI V3.0 (Huawei).",
  education: "Djakaridia est diplômé en Ingénierie Informatique et Technologies Emergentes - Option Big Data de l'École Nationale des Sciences Appliquées du Maroc (2021). Il a également complété un Cycle Préparatoire d'Ingénieur (2018) et son Baccalauréat en Sciences Exactes au Mali (2015).",
  contact: "Vous pouvez contacter Djakaridia par téléphone au (+223) 71 97 58 33 ou par email à djakaridiatraore7920@gmail.com. Il est basé au Mali et disponible pour des opportunités internationales.",
  default: "Merci pour votre intérêt ! Pour plus d'informations sur le parcours de Djakaridia, n'hésitez pas à explorer son portfolio ou à utiliser le formulaire de contact. Je peux vous renseigner sur ses compétences, ses projets internationaux ou son expérience en Big Data."
};